import * as React from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
  Grid,
  Checkbox,
  FormControlLabel,
  Snackbar,
  Link,
  Alert,
} from "@mui/material";

// import LockOutlinedIcon from '@mui/icons-material/LockOutlinedIcon';

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useContext, useState } from "react";
import { AuthContext } from "./index";

import Copyright from "./Copyright";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const theme = createTheme();

export default function SignUp() {
  const navigate = useNavigate();

  const [notification, setNotification] = useState({
    isOpen: false,
    severity: "success",
    text: "",
  });

  const { onLogin } = useContext(AuthContext);

  const EMPTY_SIGN_UP_FORM = {
    username: "",
    firstName: "",
    lastName: "",
    password: "",
    sendEmails: false,
  };

  const [signUpForm, setSignUpForm] = useState(EMPTY_SIGN_UP_FORM);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const resp = await axios.post(
        `/api/users`,
        {
          username: signUpForm.username,
          firstName: signUpForm.firstName,
          lastName: signUpForm.lastName,
          password: signUpForm.password,
          consents: [
            {
              isGiven: true,
              disclosureText: "Yes, I do allow to send me e-mails",
              consentMethod: "REGISTRATION",
            },
            {
              isGiven: signUpForm.sendEmails,
              consentMethod: "NEWSLETTER",
              disclosureText:
                "Get +20 free credits for subscribing to our monthly newsletter",
            },
          ],
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      setNotification({
        isOpen: true,
        severity: "success",
        text:
          "Verification email was sent to you address: " + signUpForm.username,
      });
      setSignUpForm(EMPTY_SIGN_UP_FORM);
    } catch (err) {
      setSignUpForm(EMPTY_SIGN_UP_FORM);
      setNotification({
        isOpen: true,
        severity: "warning",
        text: "Something went wrong during registration. Try one more time or contact support.",
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            {/*<LockOutlinedIcon />*/}
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="given-name"
                  name="firstName"
                  value={signUpForm.firstName}
                  onChange={(event) =>
                    setSignUpForm((prevState) => ({
                      ...prevState,
                      firstName: event.target.value,
                    }))
                  }
                  fullWidth
                  id="firstName"
                  label="First Name"
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  id="lastName"
                  value={signUpForm.lastName}
                  onChange={(event) =>
                    setSignUpForm((prevState) => ({
                      ...prevState,
                      lastName: event.target.value,
                    }))
                  }
                  label="Last Name"
                  name="lastName"
                  autoComplete="family-name"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  value={signUpForm.username}
                  onChange={(event) =>
                    setSignUpForm((prevState) => ({
                      ...prevState,
                      username: event.target.value,
                    }))
                  }
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  value={signUpForm.password}
                  onChange={(event) =>
                    setSignUpForm((prevState) => ({
                      ...prevState,
                      password: event.target.value,
                    }))
                  }
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      onClick={(event) =>
                        setSignUpForm((prevState) => ({
                          ...prevState,
                          sendEmails: event.target.checked,
                        }))
                      }
                    />
                  }
                  label="Get +20 free credits for subscribing to our monthly newsletter"
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleSubmit}
            >
              Sign Up
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link href="/login" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
            {notification.isOpen ? (
              <>
                <Snackbar
                  open={notification.isOpen}
                  autoHideDuration={6000}
                  onClose={() => {
                    setNotification((prevState) => ({
                      ...prevState,
                      isOpen: false,
                    }));
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <Alert
                    onClose={() => {
                      setNotification((prevState) => ({
                        ...prevState,
                        isOpen: false,
                      }));
                    }}
                    severity={notification.severity}
                    sx={{ width: "100%" }}
                  >
                    {notification.text}
                  </Alert>
                </Snackbar>
              </>
            ) : null}
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}
